import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { getIMQsZip } from 'api/operations/imqsService';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { SendOutEmailsModalStore } from 'store/general/sendOutEmailsModalStore';
import { shareIMQ } from 'api/operations/enrollmentService';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';

interface DomainParams {
  periodId: string;
  groupId: string;
  cartId: string;
}

export class DownloadIMQsPageStore {
  private readonly _domainParams: DomainParams;
  private _imqsZipName: string = '';
  private _downloadZipLink: string;
  private _isLoading = false;
  public async shareIMQ(recipients: string[]): Promise<void> {
    await shareIMQ(this._domainParams.periodId, this._domainParams.cartId, recipients);
    toastManager.addToast('IMQs have been shared', ToastColorTypes.SUCCESS);
  }

  public sendOutEmailsModalStore = new SendOutEmailsModalStore({ onSubmit: this.shareIMQ.bind(this) });

  get isLoading(): boolean {
    return this._isLoading;
  }

  get imqsZipName(): string {
    return this._imqsZipName;
  }

  public setLoading(status: boolean): void {
    this._isLoading = status;
  }

  public async getIMQsZip(): Promise<void> {
    this.setLoading(true);
    const imqsZipName = await getIMQsZip(this._domainParams.groupId, this._domainParams.cartId);
    runInAction(() => {
      this._imqsZipName = imqsZipName;
      this.setLoading(false);
    });
  }

  public downloadZip(): void {
    downloadByUrl(this._downloadZipLink);
  }

  constructor(domainParams: DomainParams) {
    this._domainParams = domainParams;
    this._downloadZipLink = `https://${process.env.REACT_APP_API_BASE_URL}/imq/Prod/download/${domainParams.cartId}`;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const DownloadIMQsPageStoreContext = createContext(new DownloadIMQsPageStore({} as DomainParams));

export const useDownloadIMQsPageStore = (): DownloadIMQsPageStore => {
  return useContext(DownloadIMQsPageStoreContext);
};

export { DownloadIMQsPageStoreContext };
